import { InjectionToken } from '@angular/core';
import { Page } from '@app/app/shared/models/page';
import { Comment, CommentSortOption, CreateCommentRequest, LikeUser, UpdateCommentRequest } from '../../models/comment/comment.model';
import { ObservableResult } from '../../store';

export const COMMENT_DATA_SERVICE = new InjectionToken<CommentDataService>('CommentDataService');

export interface CommentDataService {
  getComments(
    momentId: string,
    page: number,
    pageSize: number,
    sort: CommentSortOption['value'],
    replyFor?: string,
  ): ObservableResult<Page<Comment>>;

  createComment(request: CreateCommentRequest): ObservableResult<Comment>;

  updateComment(commentId: string, request: UpdateCommentRequest): ObservableResult<Comment>;

  deleteComment(commentId: string): ObservableResult<void>;

  likeComment(commentId: string): ObservableResult<void>;

  unlikeComment(commentId: string): ObservableResult<void>;

  getCommentLikes(commentId: string): ObservableResult<LikeUser[]>;
}
